module.exports = __webpack_public_path__ + "img/map1.8ed2af88.jpg";